var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinSmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11834_350314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.562526H2.25C1.80756 0.558023 1.3814 0.729221 1.06504 1.03856C0.74867 1.34789 0.56794 1.77009 0.5625 2.21253V21.7913C0.568923 22.2331 0.750087 22.6543 1.06634 22.9628C1.3826 23.2714 1.8082 23.442 2.25 23.4375H21.75C22.1925 23.441 22.6183 23.2693 22.9345 22.9597C23.2507 22.6502 23.4316 22.2281 23.4375 21.7857V2.2069C23.4296 1.76577 23.2479 1.34558 22.9319 1.03766C22.6159 0.729747 22.1912 0.558997 21.75 0.562526Z",
    fill: "#0076B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94969 9.1369H7.34531V20.0625H3.94969V9.1369ZM5.64844 3.6994C6.0379 3.6994 6.41861 3.81491 6.74241 4.03133C7.06621 4.24774 7.31855 4.55533 7.4675 4.91518C7.61646 5.27503 7.65534 5.67097 7.57922 6.05293C7.5031 6.43488 7.31541 6.78567 7.03989 7.06093C6.76437 7.33619 6.4134 7.52355 6.03137 7.5993C5.64935 7.67505 5.25344 7.6358 4.89373 7.4865C4.53402 7.3372 4.22667 7.08457 4.01057 6.76057C3.79447 6.43656 3.67932 6.05574 3.67969 5.66628C3.68019 5.14446 3.88783 4.64418 4.25698 4.27537C4.62614 3.90657 5.12662 3.6994 5.64844 3.6994ZM9.47531 9.1369H12.7303V10.6369H12.7753C13.2291 9.77815 14.3353 8.87253 15.9872 8.87253C19.4259 8.86503 20.0634 11.1282 20.0634 14.0625V20.0625H16.6678V14.7469C16.6678 13.4813 16.6453 11.8519 14.9034 11.8519C13.1616 11.8519 12.8653 13.2319 12.8653 14.6644V20.0625H9.47531V9.1369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11834_350314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinSmIcon);
export default __webpack_public_path__ + "static/media/linkdin-sm-icon.b9e5dab5e1f1757f6796421809704dd7.svg";
export { ForwardRef as ReactComponent };